import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Header from './components/General/Header/Header';
import Footer from './components/General/Footer/Footer';
import ScrollToTop from './ScrollToTop';
import ScrollToTopButton from './components/General/ScrollToTopButton';

import Home from './pages/Home';
import Repair from './pages/Repair';
import Maintenance from './pages/Maintenance';
import Freezer from './pages/Freezer';

import './App.scss';


const App = () => {
  return (
    <>
      <ScrollToTop />
      <ScrollToTopButton />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/repair" element={<Repair />} />
        <Route path="/maintenance" element={<Maintenance />} />
        <Route path="/freezer" element={<Freezer />} />
      </Routes>
      <Footer />
    </>
  );
};

export default App;